export const RULE_STATE = {
  IGNORED: "IGNORED",
  PASSED: "PASSED",
  PENDING: "PENDING",
};
